import KOGBoxGrid from "@/main/components/shared/kogBoxGrid/kogBoxGrid";
import KOGPaginationGrid from "@/main/components/shared/paginationGrid/paginationGrid";
import { RowHeaderTextEnd, TextEllipsis } from "@/main/components/shared/styles";
import { VoucherSearchGridRequest } from "@/main/models/request";
import { VoucherSearchGridItemResponse } from "@/main/models/response";
import RowRefund from "@/main/screens/order/refunds/components/refundsGrid/rowRefund";
import { RefundsPage } from "@/main/screens/order/refunds/refundsScreenUtils";
import { CultureEnum } from "@/main/services/enum/CultureEnum";
import { ResolutionsEnum } from "@/main/services/enum/ResolutionsEnum";
import { getTranslateByKey } from "@/main/services/utils";
import { getIdCultureUser } from "@/main/services/utilsUser";
import { Dispatch, SetStateAction } from "react";

const ID_SCROLL_TARGET = "#id-general-container-screen";

const AMOUNT_HEADER_KEY = "information.price";

const SIZE_COLUMNS_WITH_PRICE = ["8%", "11%", "9%", "16%", "12%", "14%", "12%", "9%", "9%"];

const SIZE_COLUMNS_WITHOUT_PRICE = ["8%", "11%", "9%", "16%", "12%", "23%", "12%", "9%"];

type IRefundsGrid = {
	filter: VoucherSearchGridRequest | null;
	dataGrid: VoucherSearchGridItemResponse[];
	setDataGrid: Dispatch<SetStateAction<VoucherSearchGridItemResponse[]>>;
	fetchRefunds: (request: VoucherSearchGridRequest) => Promise<RefundsPage>;
	showPrices: boolean;
};

function getLeftAlignedHeaderKeys(): string[] {
	const voucherHeaderKey = getIdCultureUser() === CultureEnum.esMX ? "information.folio" : "information.Voucher";

	return [
		"information.report",
		"information.insurer",
		"information.type",
		"information.company",
		"information.vehicle",
		"information.part",
		voucherHeaderKey,
		"information.createDate",
	];
}

function HeaderText({ labelKey }: Readonly<{ labelKey: string }>) {
	const label = getTranslateByKey(labelKey);

	return <TextEllipsis title={label}>{label}</TextEllipsis>;
}

export default function RefundsGrid({
	filter,
	dataGrid,
	setDataGrid,
	fetchRefunds,
	showPrices,
}: Readonly<IRefundsGrid>) {
	const rowHeaders = [
		...getLeftAlignedHeaderKeys().map((labelKey) => <HeaderText key={labelKey} labelKey={labelKey} />),
		showPrices ? (
			<RowHeaderTextEnd key={AMOUNT_HEADER_KEY}>
				<HeaderText labelKey={AMOUNT_HEADER_KEY} />
			</RowHeaderTextEnd>
		) : null,
	];

	return (
		<KOGPaginationGrid
			showTitleResults
			dataGrid={dataGrid}
			formFilters={filter}
			setDataGrid={setDataGrid}
			fetchEqualFilters
			fetchMore={fetchRefunds}
			idScrollableTarget={ID_SCROLL_TARGET}
		>
			<KOGBoxGrid
				rowHeaders={rowHeaders}
				breakpointTable={ResolutionsEnum.desktop}
				sizeColumns={showPrices ? SIZE_COLUMNS_WITH_PRICE : SIZE_COLUMNS_WITHOUT_PRICE}
			>
				{dataGrid.map((refund, index) => (
					<RowRefund key={`${refund.voucherCode}-${index}`} refund={refund} index={index} showPrices={showPrices} />
				))}
			</KOGBoxGrid>
		</KOGPaginationGrid>
	);
}
